import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "content--center" }
const _hoisted_2 = { class: "grid place-items-center space-y-2 p-12" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 1,
  class: "text-lg font-semibold"
}
const _hoisted_5 = {
  key: 2,
  class: "text-gray-info text-sm font-medium"
}

interface Props {
  src?: string;
  title?: string;
  description?: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    src: null,
    title: null,
    description: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.src)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.src,
            alt: `${__props.title} not found`
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (__props.title)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(__props.title), 1))
        : _createCommentVNode("", true),
      (__props.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.description), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})